import React, { useRef, Children } from 'react';
import { CheckCircleIcon, CalendarIcon } from 'lucide-react';
import { Button } from '../ui/Button';
import { motion, useScroll, useTransform } from 'framer-motion';
export function FinalCTA() {
  const sectionRef = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start']
  });
  // Scale up as it comes into view
  const scale = useTransform(scrollYProgress, [0, 0.3, 0.5], [0.9, 1, 1]);
  const opacity = useTransform(scrollYProgress, [0, 0.2], [0.5, 1]);
  const callBenefits = ['We look for your recruiting bottlenecks.', 'We map out a custom system for your team.', 'We tell you honestly if we are a fit.'];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -20
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.4,
        ease: [0.25, 0.1, 0.25, 1]
      }
    }
  };
  return <section ref={sectionRef} className="section-padding bg-white overflow-hidden" data-id="element-287">
      <div className="container-custom" data-id="element-288">
        <motion.div className="max-w-4xl mx-auto text-center" style={{
        scale,
        opacity
      }} data-id="element-289">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          ease: [0.25, 0.1, 0.25, 1]
        }} data-id="element-290">
            <div className="inline-block bg-mint/10 text-mint-dark px-4 py-2 rounded text-sm font-semibold mb-4 md:mb-6" data-id="element-291">
              Ready to Scale?
            </div>

            <h2 className="mb-4 md:mb-6" data-id="element-292">Build Your Recruiting System</h2>

            <p className="text-body-large mb-8 md:mb-10 lg:mb-12 leading-relaxed" data-id="element-293">
              If you want a real framework that works without you micromanaging
              it, let's talk. No pressure. Just a strategy session.
            </p>
          </motion.div>

          <motion.div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-6 md:p-8 lg:p-12 mb-8 md:mb-10 lg:mb-12 border-2 border-gray-200 shadow-lg" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} whileHover={{
          borderColor: '#7FE0C3',
          boxShadow: '0 20px 40px -15px rgba(127, 224, 195, 0.2)',
          transition: {
            duration: 0.3
          }
        }} data-id="element-294">
            <div className="flex items-center justify-center mb-4 md:mb-5 lg:mb-6" data-id="element-295">
              <motion.div animate={{
              rotate: [0, 5, -5, 0]
            }} transition={{
              duration: 2,
              repeat: Infinity,
              repeatDelay: 3
            }} data-id="element-296">
                <CalendarIcon className="h-6 w-6 md:h-7 md:w-7 lg:h-8 lg:w-8 text-mint mr-2 md:mr-3" data-id="element-297" />
              </motion.div>
              <h3 data-id="element-298">What Happens on the Call</h3>
            </div>

            <motion.ul className="space-y-3 md:space-y-4 text-left max-w-2xl mx-auto" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
            once: true
          }} data-id="element-299">
              {callBenefits.map((benefit, index) => <motion.li key={index} className="flex items-start" variants={itemVariants} data-id="element-300">
                  <CheckCircleIcon className="h-5 w-5 md:h-6 md:w-6 text-mint flex-shrink-0 mr-2 md:mr-3 mt-0.5" data-id="element-301" />
                  <span data-id="element-302">{benefit}</span>
                </motion.li>)}
            </motion.ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} data-id="element-303">
            <Button size="lg" href="/book-call" showArrow data-id="element-304">
              Schedule Your Strategy Call
            </Button>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}